import { render, staticRenderFns } from "./ProductSpecificationsList.vue?vue&type=template&id=495d567a&scoped=true"
import script from "./ProductSpecificationsList.vue?vue&type=script&lang=js"
export * from "./ProductSpecificationsList.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecificationsList.vue?vue&type=style&index=0&id=495d567a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d567a",
  null
  
)

export default component.exports